export default {
	// set apiUrl on server where is our node api is running
	apiUrl:'https://backend.dokkit.co.uk',
	stripePublishableKey: 'pk_live_OdOAepCji6zFGBnl8WM3LmXT',
	env : 'production', 
}




// WEBPACK FOOTER //
// ./src/config/env.js